import * as React from "react"
import { useContentfulInspectorMode } from "@contentful/live-preview/react"
import { Row } from "react-grid-system"
import H4 from "../atoms/typography/H4"
import { LogoShowcaseModel } from "./models"
import PageContentWrapper from "../organisms/PageContentWrapper"
import { HorizontalSpacer } from "../atoms/spacers"

const LogoShowcase: React.FC<LogoShowcaseModel> = ({ sys, logosCollection, title }) => {
  const inspectorProps = useContentfulInspectorMode({ entryId: sys?.id })
  return (
    <PageContentWrapper>
      <HorizontalSpacer spacing={1} />
      <Row justify="center">
        <H4 textAlign="center">{title}</H4>
      </Row>
      <HorizontalSpacer spacing={1.5} />
      <Row justify="around" {...inspectorProps({ fieldId: "logos" })}>
        {logosCollection?.items.map(({ url, description }) => (
          <img style={{ maxHeight: "100px" }} src={url} alt={description} key={url} />
        ))}
      </Row>
    </PageContentWrapper>
  )
}

export default LogoShowcase
